import appAxios from "../services/axios";

export const postGlyphSlot = async ({ treeId, glyphSlot }) => {
  const resp = await appAxios.post(`/api/glyphslot/${treeId}`, {
    glyphSlot: glyphSlot,
  });
  return resp.data;
};

export const getGlyphSlots = async ({ treeId }) => {
  let url = "/api/glyphslot";
  if (treeId) {
    url += `/${treeId}`;
  }
  const resp = await appAxios.get(url);
  return resp.data;
};

export const deleteTreeGlyphSlots = async ({ treeId }) => {
  const resp = await appAxios.delete(`/api/glyphslot/${treeId}`);
  return resp.data;
};

export const deleteTreeGlyphSlotsLast = async ({ treeId }) => {
  const resp = await appAxios.delete(`/api/glyphslot/${treeId}/last`);
  return resp.data;
};
